var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"c-checkbox"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked}}),_c('div',{staticClass:"c-checkbox__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }